"use client";

const TOOLTIPS_DATA = {
  // Conceptual explanations for various fields and actions in the UI
  Prototype: {
    when_extracting: `
    Which profile perspective should shape these suggestions?\n
    Profile perspectives are the angles used to view your career profile:\n
    * Practical skills (what you can do)
    * Domain knowledge (what you know about)
    * Preferences (where you thrive)
    * Awareness (how you see yourself)
    `,
  },
  Situation: {
    Position: `
    What should this career-relevant moment be called?\n
    * if occupational experience: i.e. Role, Job Title, Project, etc.
    * if educational experience: i.e. Course, Program, Subject, etc.
    * or any title that helps you recognize this moment later
    `,
    Context: `
    Where did this career-relevant moment happen?\n
    * if occupational experience: i.e. Company, Client, Team, etc.
    * if educational experience: i.e. University, School, Program, etc.
    * or any context that helps anchor the thoughts
    `,
    Status: `
    What is the time status of this situation?\n
    * future means you are aiming toward it
    * started means it is currently in progress or already in the past
    `,
    Category: {
      occupation: `
      Select if this situation stands for your occupational experience.\n 
      i.e. it is related to your job, work, or professional activity.
      `,
      education: `
      Select if this situation stands for your educational experience.\n
      i.e. it is related to your studies, courses, or academic activity.
      `,
    },
    when_extracting: `
    Which situation should anchor this experience?\n
    * choose a career-relevant moment from the list
    * if you don't have any situations yet, add one first
    `,
  },
  Language: {
    general: `
    What language is the input written in?\n
    * if not delected automatically, select one from the list
    * or report us a new language to add its support
    `,
    when_extracting: `
    What language should the response be (translated) in? 
    * if not delected automatically, select one from the list
    * or report us a new language to add its support
    `,
  },
  InputMaterial: {
    when_extracting: `
    Provide text material which reflects your career related experience, i.e.:\n
    * blog post
    * job description
    * company website
    * technical documentation
    * or any other text material that you find relevant
    `,
  },
  Target: {
    Position: `
    What should this focus lens be called?\n
    * i.e. Role, Job Title, Program, Opportunity, etc.
    `,
    Context: `
    What is the context of this focus lens?\n
    * i.e. Company, Project, School, Client, Team, etc.
    `,
    Content: `
    What should MoveOn use as the focus lens?\n
    * job post
    * role brief
    * program description
    * opportunity notes
    * or any other text that describes what the output should emphasize
    `,
    when_selecting: `
    Choose a focus lens to bring the most relevant confirmed thoughts forward.\n
    * if you don't have any focus yet, add one from a job post, role brief, or opportunity notes
    `,
  },

  // Technical explanations of actions user does with the system
  actions: {
    save: "Save changes (Ctrl+Enter)",
    remove: "Remove record (Ctrl+Delete)",
    lock: "Lock item to prevent changes",
    unlock: "Unlock item for manupulation",
    previewReflections: "See reflections",
  },
};

const TOOLTIPS = Object.freeze(TOOLTIPS_DATA);
export default TOOLTIPS;
